import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {FITHGameModuleConfig} from "../FITHGameModuleConfig";
import {FITHGameMode} from "../gameMode/FITHGameMode";
import {FITHGameConfig} from "../FITHGameConfig";

export class FITHSpinController extends SpinController {
    private static REELS_TO_SPIN_BONUS_GAME_DEFAULT: boolean[] = [false, true, true, false, false, false, false, true, true, false, false, false, false, true, true, false, false, false, false, true, true, false, false, false, false, true, true, false, false, false, false, true, true, false, false, false];
    private _reelsToSpinBonusGame: boolean[] = [false, true, true, false, false, false, false, true, true, false, false, false, false, true, true, false, false, false, false, true, true, false, false, false, false, true, true, false, false, false, false, true, true, false, false, false];
    private _reelsToSpinBaseGame: boolean[] = [true, true, true, true, true, true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false];
    private _firstActiveReelInBonus: number;
    private _lastActiveReelInBonus: number;

    /**
     * @description Think of it as a method called on SpinEvent.BEFORE_START. Via this we avoid the registration of such event.
     * @private
     */
    private static actSpinEventBeforeStart(): void {
        FITHGameModuleConfig.reelFrameView.resetBarrierUp();
        FITHGameModuleConfig.winWaysBoard.onBeforeSpinStart();
        FITHGameModuleConfig.symbolWinAnimations.reset();
        FITHGameModuleConfig.bonusGameSpinNWagonAnimations.beforeSpinStart(false);
        FITHGameModuleConfig.wildMultiplierView.hideMultiplierItem();
    }

    public getSpinStatusOfReel(id: number): boolean {
        return this._reelsToSpinBonusGame[id];
    }

    public checkIfAnyActive(fromId: number, toId: number): boolean {
        return (this._reelsToSpinBonusGame.slice(fromId, toId).indexOf(true) > -1);
    }

    public resetBonusReelsToSpin(): void {
        // deep copy here.
        this._reelsToSpinBonusGame = [...FITHSpinController.REELS_TO_SPIN_BONUS_GAME_DEFAULT];
    }

    public enableBonusReel(reel: number): void {
        this._reelsToSpinBonusGame[reel] = true;
    }

    public disableBonusReel(reel: number): void {
        this._reelsToSpinBonusGame[reel] = false;
    }

    public getFirstActiveReelInBonus(): number {
        return this._firstActiveReelInBonus;
    }

    public getLastActiveReelInBonus(): number {
        return this._lastActiveReelInBonus;
    }

    public getReelsToSpinBonusGame(): boolean[] {
        return this._reelsToSpinBonusGame;
    }

    /**
     * @inheritDoc
     * @override For avalanche mode spin time.
     */
    protected getSpinTime(): number {
        if (this._mode === FITHGameMode.NORMAL_AVALANCHE) {
            return FITHGameConfig.instance.REEL_SPIN_TIME_AVALANCHE;
        } else if (this._mode === FITHGameMode.BONUS) {
            return FITHGameConfig.instance.REEL_SPIN_TIME_BONUS_GAME;
        }

        return super.getSpinTime();
    }

    protected startSpin(): void {
        FITHSpinController.actSpinEventBeforeStart();

        if (this._mode === FITHGameMode.BONUS) {
            FITHGameModuleConfig.reelFrameView.updateSpinsLeftBoardText();

            this.calculateFirstActiveReelInBonusGame();
            this.calculateLastActiveReelInBonusGame();
            return;
        }

        // #303 -> alternate
        if (this._mode === FITHGameMode.NORMAL && FITHSpinController.MIN_SPIN_TIME > 0) {
            FITHGameModuleConfig.logoView.playLogoAnimation();
        }

        super.startSpin();
    }

    protected getReelsGameConfigFromPreviousGameData(): boolean[] {
        if (this._mode === FITHGameMode.BONUS || this._nextMode === FITHGameMode.BONUS) {
            return this._reelsToSpinBonusGame;
        } else {
            return this._reelsToSpinBaseGame;
        }
    }

    private calculateFirstActiveReelInBonusGame(): void {
        this._firstActiveReelInBonus = -1;

        let retVal: number,
            reelIds: number[],
            subArray: boolean[];

        // calculating top to bottom and not counting the top most wagon row.
        for (let i: number = 1; i < 5; i++) {
            subArray = [];
            reelIds = [];
            for (let j: number = i; j < this._reelsToSpinBonusGame.length; j += 6) {
                reelIds.push(j);
                subArray.push(this._reelsToSpinBonusGame[j]);
            }
            retVal = subArray.indexOf(true);
            if (retVal > -1) {
                this._firstActiveReelInBonus = reelIds[retVal];
                return; // we don't want this to be set again for another row.
            }
        }
    }

    private calculateLastActiveReelInBonusGame(): void {
        this._lastActiveReelInBonus = -1;

        let retVal: number,
            reelIds: number[],
            subArray: boolean[];

        // calculating bottom to top and not counting the top most wagon row.
        for (let i: number = 5; i > 0; i--) {
            subArray = [];
            reelIds = [];
            for (let j: number = i; j < this._reelsToSpinBonusGame.length; j += 6) {
                reelIds.push(j);
                subArray.push(this._reelsToSpinBonusGame[j]);
            }
            retVal = subArray.lastIndexOf(true);
            if (retVal > -1) {
                this._lastActiveReelInBonus = reelIds[retVal];
                return; // we don't want this to be set again for another row.
            }
        }
    }
}